import { Button, Paper } from "@material-ui/core";
import { ceil, range } from "lodash";
import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../../i18n/util";
import { API } from "../../../network/API";
import { authStore } from "../../../stores/AuthStore";
import { generalStore } from "../../../stores/GeneralStore";
import { useHideNavigation } from "../../hooks/useHideNavigation";
import { useMobileMediaQuery } from "../../hooks/useMobileMediaQuery";
import { useWindowSize } from "../../hooks/useWindowSize";
import { GoogleButton } from "../../ui/GoogleButton";
import { ImageLogo } from "../../ui/Primitives";
import { Robot, ROBOT_HEIGHT } from "../../ui/Robot";

export const LoginSite = observer(() => {
    useHideNavigation();
    const isMobile = useMobileMediaQuery();

    const [width, height] = useWindowSize();

    const handleClickLogin = async () => {
        try {
            const authUrl = await authStore.getGoogleLoginUrl();
            window.open(authUrl, "_self");
        } catch (error) {
            generalStore.setError(t("error.login"), error);
        }
    };

    return (
        <div style={{ height: "100vh", overflow: "hidden" }} className="loginSite">
            <Paper
                elevation={5}
                style={{
                    position: "fixed",
                    left: isMobile ? "calc(50% - 20px)" : "50%",
                    top: "50%",
                    margin: isMobile ? 20 : 0,
                    width: isMobile ? "fit-content" : "auto",
                    transform: "translate(-50%, -50%)",
                    zIndex: 3,
                    padding: 40,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    maxWidth: 450,
                    gap: 40
                }}
                className="blackDalBorder"
            >
                <ImageLogo
                    style={{
                        maxWidth: "70%"
                    }}
                />
                <h2 style={{ textAlign: "center" }}>{t("screen.login.hrbot")}</h2>
                <p style={{ textAlign: "center" }}>
                    <b>{t("screen.login.hrbot")}</b>
                    {t("screen.login.welcome")}
                </p>
                <GoogleButton onClick={handleClickLogin} />
            </Paper>
            {range(ceil(height / ROBOT_HEIGHT)).map((indexVert) => (
                <div
                    key={indexVert}
                    style={{
                        display: "flex",
                        overflow: "hidden",
                        filter: "brightness(90%)",
                        marginLeft: -100 * indexVert
                    }}
                >
                    {range(ceil(width / ROBOT_HEIGHT) + indexVert).map((indexHor) => (
                        <Robot key={indexHor} />
                    ))}
                </div>
            ))}
        </div>
    );
});
